import PasswordValidationComponent from "@components/find/PasswordValidationComponent";

export default function VerifyPassword() {
  return (
    <PasswordValidationComponent
      title="비밀번호를 입력해주세요."
      fieldName="password"
      fieldConfirmName="passwordConfirm"
      type="signup"
    />
  );
}
